import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { emailSelector } from '../selectors/authSelectors';
import { storeSecurityCode } from '../actions/authActions';
import SecurityCodeForm from '../components/SecurityCodeForm/SecurityCodeForm';

const mapStateToProps = createStructuredSelector({ email: emailSelector });
const mapDispatchToProps = { storeSecurityCode };

export default connect(mapStateToProps, mapDispatchToProps)(SecurityCodeForm);
